import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import moment from "moment";
import { initialFilters, periods } from "../../financeiro/constants";

export const taxNotesColumns = [
  {
    label: "Empresa",
    id: "company",
  },
  {
    label: "ID",
    id: "id",
  },
  {
    label: "Nº Nota",
    id: "noteNumber",
    sorting: "disabled",
  },
  {
    label: "Nº RPS",
    id: "rpsNumber",
    sorting: "disabled",
  },
  {
    label: "Razão Social",
    id: "description",
    sorting: "disabled",
    style: {
      whiteSpace: "nowrap",
    },
    format: (item) => item ?? "Sem razão social",
  },
  {
    label: "Data Emissão",
    id: "emissionDate",
    minWidth: 125,
    sorting: "asc",
    format: (item) => moment(item).format("DD/MM/YYYY"),
  },
  {
    label: "Valor Total (R$)",
    id: "totalAmount",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "ISS (%)",
    id: "issPerCent",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "ISS (R$)",
    id: "issAmount",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Status",
    id: "status",
    sorting: "disabled",
  },
];

export const taxNotesStatus = {
  Todos: null,
  Autorizada: "authorized",
  Cancelada: "canceled",
  Negada: "denied",
};

export const xlsxGroupEmptyDescription = {
  modality: "Sem modalidade",
  status: "Sem status",
  type: "Sem tipo de serviço",
};

export const sortIcon = {
  disabled: <ArrowUpward fontSize="inherit" color="disabled" />,
  asc: <ArrowUpward fontSize="inherit" color="primary" />,
  desc: <ArrowDownward fontSize="inherit" color="primary" />,
};

export const initialTaxFilter = {
  multicompany: initialFilters.multicompany,
  period: periods["Este mês"],
  status: taxNotesStatus.Todos,
  multipleSort: JSON.stringify([
    {
      column: "emissionDate",
      direction: "asc",
    },
  ]),
};
